import { gql } from '@apollo/client';

export const PROFILE_FIELDS = gql`
  fragment ProfileFields on Profile {
    firstName
    lastName
    contactId
    addressId
    uid
    profileId
  }
`;
